<template>
    <div class="relative">
        <ChatBubbleLeftRightIcon
            class="h-5 w-5"
            @mouseover="showUnresolvedConversationsTooltip = true"
            @mouseleave="showUnresolvedConversationsTooltip = false"
        />

        <transition
            enter-active-class="transition duration-100 ease-out transform"
            enter-from-class="scale-95 opacity-0"
            enter-to-class="scale-100 opacity-100"
            leave-active-class="transition duration-75 ease-in transform"
            leave-from-class="scale-100 opacity-100"
            leave-to-class="scale-95 opacity-0"
        >
            <Tooltip
                v-if="showUnresolvedConversationsTooltip"
                class="absolute bottom-9"
                style="left: 50%; transform: translate(-50%, 0)"
            >
                Template has unresolved conversations
            </Tooltip>
        </transition>
    </div>
</template>
<script lang="ts" setup>
import { ChatBubbleLeftRightIcon } from '@heroicons/vue/24/solid';

const showUnresolvedConversationsTooltip = ref(false);
</script>
